import { createAsyncThunk } from '@reduxjs/toolkit';
import { getUser } from 'services/user/user.service';
import { IUser } from 'services/user/types';

export const ThunkGetUser = createAsyncThunk<IUser, number>('user/getUser', userId =>
  getUser(userId).then(r => r.data),
);
